import clsx from 'clsx'

export interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  kind?:
    | 'primary'
    | 'primary-bw'
    | 'secondary'
    | 'secondary-bw'
    | 'alert'
    | 'text'
    | 'text-white'
    | 'blur-white'
    | 'icon'
    | 'choice-bw'
  size?: 'md' | 'lg' | 'none'
  disabled?: boolean
}

export const Button = (props: ButtonProps) => {
  const { className, children, kind = 'primary', size = 'lg', ...rest } = props || {}

  const isPrimary = kind === 'primary'
  const isPrimaryBW = kind === 'primary-bw'
  const isSecondary = kind === 'secondary'
  const isSecondaryBW = kind === 'secondary-bw'
  const isAlert = kind === 'alert'
  const isText = kind === 'text'
  const isTextWhite = kind === 'text-white'
  const isBlurWhite = kind === 'blur-white'
  const isIcon = kind === 'icon'
  const isChoiceBW = kind === 'choice-bw'

  const isSizeMd = size === 'md'
  const isSizeLg = size === 'lg'
  const isSizeNone = size === 'none'
  return (
    <button
      {...rest}
      className={clsx(
        'font-bold',
        'inline-flex items-center justify-center gap-2 box-border',
        'rounded-full',
        'cursor-pointer pointer-events-auto disabled:pointer-events-none',

        isPrimary && 'border-0',
        isPrimary && 'bg-interactive-filled-default hover:bg-primary-50 disabled:bg-surface-subdued',
        isPrimary && 'text-text-on-interactive disabled:text-text-disabled',

        isPrimaryBW && 'border-0',
        isPrimaryBW && 'bg-neutral-warm-95 hover:bg-neutral-warm-90 disabled:bg-neutral-warm-95',
        isPrimaryBW && 'text-text-default disabled:text-text-disabled',

        isSecondary && 'border border-border-default disabled:border-interactive-filled-disabled',
        isSecondary && 'bg-surface-default hover:bg-neutral-warm-95 disabled:bg-surface-subdued',
        isSecondary && 'text-text-interactive hover:text-primary-50 disabled:text-text-disabled',

        isSecondaryBW && 'border border-neutral-cool-70 disabled:border-interactive-filled-disabled',
        isSecondaryBW && 'bg-surface-default hover:bg-neutral-cool-95 disabled:bg-surface-subdued',
        isSecondaryBW && 'text-text-default disabled:text-text-disabled',

        isChoiceBW && 'border border-border-subdued disabled:border-interactive-filled-disabled',
        isChoiceBW && 'bg-surface-default hover:bg-neutral-cool-95 disabled:bg-surface-subdued',
        isChoiceBW && 'text-text-subdued disabled:text-text-disabled',
        isChoiceBW && 'font-normal h-[48px] text-body-text-3',

        isAlert && 'border-0',
        isAlert && 'bg-interactive-alert-default hover:bg-interactive-alert-hovered disabled:bg-surface-subdued',
        isAlert && 'text-text-on-interactive disabled:text-text-disabled',

        isText && 'border-0',
        isText && 'bg-transparent disabled:bg-surface-subdued',
        isText && 'text-text-interactive hover:text-primary-50 disabled:text-text-disabled',

        isTextWhite && 'border-0',
        isTextWhite && 'bg-transparent hover:bg-white/20 disabled:bg-surface-subdued',
        isTextWhite && 'text-white disabled:text-white/50',

        isBlurWhite && 'border-0',
        isBlurWhite && 'bg-white bg-opacity-20 hover:bg-opacity-30',
        isBlurWhite && 'text-white disabled:text-white/50',

        isIcon && 'border-0',
        isIcon && 'bg-transparent hover:bg-white/10',
        isIcon && 'text-text-default rounded-lg',

        isSizeMd && 'py-[10px] px-4 text-sm',
        isSizeLg && 'py-[14px] px-7 text-body-text-2 ',
        isSizeNone && 'p-0',

        className,
      )}
    >
      {children}
    </button>
  )
}
